/**
 * Web component that pre-selects the browser's UTC offset in a select, for a new time window filter.
 *
 * Set `data-browser-default="true"` on the component to select the offset. For any other value, including the empty string Razor
 * renders for a null `data-` attribute, the select is left as it was rendered.
 */
class TimeOffsetSelect extends HTMLElement {
    constructor() {
        super();

        const select = this.querySelector('select');
        if (!select || this.dataset.browserDefault !== 'true') {
            return;
        }

        // getTimezoneOffset is minutes west of UTC, and may be -0
        const offset = -new Date().getTimezoneOffset() || 0;
        const option = [...select.options].find(x => Number(x.value) === offset);
        if (option) {
            select.value = option.value;
        }
    }
}

// Define the new web component
if ('customElements' in window) {
    customElements.define('nilla-time-offset', TimeOffsetSelect);
}

export default TimeOffsetSelect;
